import axios from 'axios';
import { customEvent } from '@jspartials/general-utils';
import { initCarousel } from '@jspartials/recommendations-utils';

const endpointToGetRecommendationsByEinstein =
  globalVariables.endpoint.getRecommendations;
const eventReloadVtoButtons = new CustomEvent('reloadVtoButtons');

export default class Recommendations {
  constructor(options) {
    let defaults = {
      wrapper: '',
      showPrice: true,
      maxVisibleItems: 4,
      staticContent: false
    };
    this.observer = null;
    this.options = Object.assign(defaults, options);
    this.recommenderId = this.options.wrapper?.dataset?.recommenderId;

    if (this.options.staticContent) {
      initCarousel({
        wrapper: this.options.wrapper,
        maxVisibleItems: this.options.maxVisibleItems
      });
      this.observeRecommender();
    } else {
      this.initRecommendations();
    }
  }

  skeletonPlaceholder() {
    var skeletonContent = '';

    for (var i = 0; i < this.options.maxVisibleItems; i++) {
      skeletonContent += `
      <li class="tw-flex tw-flex-col tw-min-w-[40%] md:tw-w-full tw-h-full tw-space-y-2">
        <div class="hw-recommendations__carousel-skeleton hw-recommendations__carousel-skeleton-image"></div>
        <p class="hw-recommendations__carousel-skeleton tw-w-full tw-h-3"></p>
        <p class="hw-recommendations__carousel-skeleton tw-w-3/6 tw-h-3"></p>
      </li>`;
    }

    const skeleton = `
      <ul
        class="tw-flex tw-gap-4 tw-overflow-x-hidden md:tw-p-0 md:tw-grid-flow-col md:tw-grid hw-recommendations__carousel"
        style="--recommendations-max-visible-items: ${this.options.maxVisibleItems};"
      >
        ${skeletonContent}
      </ul>
    `;

    return skeleton;
  }

  initRecommendations() {
    this.options.wrapper.innerHTML = this.skeletonPlaceholder();
    this.initRecommendationsByEinstein();
  }

  initRecommendationsByEinstein() {
    let einsteinUtils;
    einsteinUtils = window.CQuotient;
    const einsteinId = this.recommenderId;
    const masterProductId = this.options.wrapper.dataset.masterProductId;
    const productSku = this.options.wrapper.dataset.productId;
    const category = this.options.wrapper.dataset.category;

    if (
      einsteinUtils &&
      einsteinId !== '' &&
      typeof einsteinUtils.getCQUserId === 'function' &&
      typeof einsteinUtils.getCQCookieId === 'function'
    ) {
      var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
      };

      if (category) {
        params.anchors = [
          {
            id: category
          }
        ];
      } else {
        params.anchors = [
          {
            id: masterProductId,
            sku: productSku
          }
        ];
      }

      if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(
          einsteinUtils.clientId,
          einsteinId,
          params,
          (masterProducts) => {
            this.getRecommendations(masterProducts);
          }
        );
      } else {
        einsteinUtils.widgets = einsteinUtils.widgets || [];
        einsteinUtils.widgets.push({
          recommenderName: einsteinId,
          parameters: params,
          callback: (masterProducts) => {
            this.getRecommendations(masterProducts);
          }
        });
      }
    } else {
      console.error("Recommendations can't be loaded.");
    }
  }

  getRecommendations(masterProducts) {
    const recommenderContext =
      this.options.wrapper?.dataset?.recommenderContext || '';

    axios
      .get(endpointToGetRecommendationsByEinstein, {
        params: {
          recommenderId: this.recommenderId,
          recommenderContext: recommenderContext,
          items: masterProducts,
          showPrice: this.options.showPrice,
          maxVisibleItems: this.options.maxVisibleItems
        }
      })
      .then((response) => {
        if (response.status === 200) {
          this.renderRecommendations(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderRecommendations(recommendationsHtml) {
    this.options.wrapper.innerHTML = recommendationsHtml;
    initCarousel({
      wrapper: this.options.wrapper,
      maxVisibleItems: this.options.maxVisibleItems
    });
    document.dispatchEvent(new Event(customEvent.listenProductTiles));
    document.dispatchEvent(eventReloadVtoButtons);
    if (this.recommenderId === 'addons-in-cart-product-to-product') {
      document.dispatchEvent(new Event(customEvent.listenAddonTiles));
    }
    this.observeRecommender();
  }

  observeRecommender() {
    this.observer = new IntersectionObserver(
      this.handleRecommenderVisibility.bind(this),
      {
        root: null,
        threshold: 0.5
      }
    );
    this.observer.observe(this.options.wrapper);
  }

  handleRecommenderVisibility(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.unobserve(entry.target);
      }
    });
  }
}
